import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Container,
  Dropdown,
  Form,
  Overlay,
  Row,
  Tooltip,
} from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import addbutton from "../assets/images/addbutton.svg";
import blueaddicon from "../assets/images/blueaddicon.svg";
import closeImage from "../assets/images/close-white.svg";
import deleteAction from "../assets/images/deleteaction.svg";
import dummyBanner from "../assets/images/dummyBanner.png";
import editAction from "../assets/images/editaction.svg";
import { default as infoIcon } from "../assets/images/infobtnblue.svg";
import DemoLogo from "../assets/images/quantummain.svg";
import robot from "../assets/images/robot.gif";
import AddEditFaqModal from "../Modals/AddEditFaqModal";
import AddEditParameterModal from "../Modals/AddEditParameterModal";
import AIImageGenerateModal from "../Modals/AIImageGenerateModal";
import DeleteParaFAQModal from "../Modals/DeleteParaFAQModal";
import { apiResponse } from "../services/APIResponse";
import { API_URL } from "../services/APIRoute";
import { commonservices } from "../services/CommonServices";
import { CONFIG_COMPONENT_NAME } from "../services/configComponent";
import { CategoryGetListDetail } from "../services/ReduxTookit/Slice/CategoryRedux";
import { GetList } from "../services/ReduxTookit/Slice/IndustryRedux";
import { LogoGetList } from "../services/ReduxTookit/Slice/LogoRedux";
import { FaqGetList } from "../services/ReduxTookit/Slice/MachineFaqRedux";
import {
  GetMachineDetailByPrimaryKey,
  GetMachineDropdownList,
} from "../services/ReduxTookit/Slice/MachineRedux";
import { ProjectTermGetList } from "../services/ReduxTookit/Slice/ProjectTermRedux";
import { steps } from "../services/WalkThroughSteps";
import BreadcrumbsNav from "./common-component/BreadcrumbsNav";
import CKeditorComponent from "./common-component/CKeditorComponent";
import CustomLogoUploadPopup from "./common-component/CustomLogoUploadPopup";
import DropFileInput from "./common-component/DropFileInput";
import MainpageLoader from "./common-component/Loaders/MainpageLoader";
import SubmitLoading from "./common-component/Loaders/SubmitLoading";
import Nodata from "./common-component/Nodata";
import Walkthrough from "./common-component/Walkthrough";
import DemoLogoBig from "../assets/images/MainLogoforMPD.svg";
import OrganizationAlertModal from "../Modals/OrganizationAlertModal";

const AddMachine = () => {
  const OrganizationList = useSelector(
    (state) => state?.userinfo?.Organizations
  );
  const walkthroughDetail = commonservices.getWalkthroughDetail();
  const [callApi, setCallApi] = useState(
    walkthroughDetail?.addMachine ? walkthroughDetail?.addMachine : false
  );
  const { machineid } = useParams();

  const [mainImage, setMainImage] = useState("");
  let navigate = useNavigate();
  const [BannerImgValidation, setBannerImgValidation] = useState(
    "This Field is a required field."
  );
  const [MachineLogoValidation, setMachineLogoValidation] = useState(
    "This Field is a required field."
  );
  const [CategoryList, setCategoryList] = useState([]);
  const [MachineBannerUpgradelist, setMachineBannerUpgradelist] = useState([]);
  const [AIModalShow, setAIModalShow] = useState(false);
  const [InvalidParaShowBtn, setInvalidParaShowBtn] = useState(true);
  const [MachineDetailLoader, setMachineDetailLoader] = useState(false);
  const [DeleteparafaqShow, setDeleteparafaqShow] = useState(false);
  const [showOrgAlertModal, setShowOrgAlertModal] = useState(false);
  const [Deleteparafaqtype, setDeleteparafaqtype] = useState({
    type: "",
    index: "",
  });
  const [BannerImageState, setBannerImageState] = useState("");
  const target1 = useRef(null);
  const [show, setShow] = useState(false);
  const [FileRemoveButton, setFileRemoveButton] = useState(false);
  const [IndustryList, setIndustryList] = useState([]);
  const [MachineList, setMachineList] = useState([]);
  const [MachineLoader, setMachineLoader] = useState(false);
  const [ParameterModalShow, setParameterModalShow] = useState(false);
  const [ParameterModalType, setParameterModalType] = useState("");
  const [ParameterModalIndex, setParameterModalIndex] = useState("");
  const [ProjectTermList, setProjectTermList] = useState({
    CPU: [],
    OS: [],
    RAM: [],
    Storage: [],
    Cloud: [],
    InputType: [],
  });
  const [MultiSelectValidation, setMultiSelectValidation] = useState({
    machinebanner: false,
    machinelogo: false,
  });
  const [showSortAndFilter, setShowSortAndFilter] = useState(false);
  const handleOverlay = (e) => {
    let element = document.getElementById(e?.currentTarget?.id);
    if (element) {
      if (element.classList.contains("overlay-isopen")) {
        element.classList.remove("overlay-isopen");
      } else {
        element.classList.add("overlay-isopen");
      }
    }
  };

  const handleshowSortAndFilter = (e) => {
    if (document.getElementById("body").classList.contains("popup-is-open")) {
      document.getElementById("body").classList.remove("popup-is-open");
      handleOverlay(e);
    } else {
      document.getElementById("body").classList.add("popup-is-open");
    }
    setShowSortAndFilter(!showSortAndFilter);
  };
  const MachineLogoref = useRef();
  const Pdfref = useRef();
  const InputFileRef = useRef();
  const [InputSpecificationfile, setInputSpecificationFile] = useState();
  const [MachineLogoList, setMachineLogoList] = useState([]);
  const [MachineLogoLoader, setMachineLogoLoader] = useState(false);
  const OutputFileRef = useRef();
  const [OutputSpecificationfile, setOutputSpecificationFile] = useState();
  const [file, setFile] = useState("");
  const [showFaqModal, setShowFaqModal] = useState(false);
  const faqDetailRef = useRef();
  const handleFaqList = (data) => {
    if (data?.id >= 0) {
      let updatedData = input?.machinefaqs?.map((item, index) => {
        if (index === data?.id) {
          item.question = data?.question;
          item.answer = data?.answer;
          delete data?.id;
        }
        return item;
      });

      setInput({
        ...input,
        machinefaqs: updatedData,
      });
    } else {
      if (data?.id) {
        delete data?.id;
      }
      if (input?.machinefaqs) {
        setInput({
          ...input,
          machinefaqs: [...input?.machinefaqs, data],
        });
      } else {
        setInput({
          ...input,
          machinefaqs: [data],
        });
      }
    }
  };
  const closeFaqModal = () => {
    setShowFaqModal(false);
  };
  const BreadcrumbSingle = [
    {
      name: "Add Machine",
      link: "/marketplace/addMachine",
      active: true,
    },
  ];
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const faqListRef = useRef();
  const dispatch = useDispatch();
  const [input, setInput] = useState({
    machineid: 0,
    categoryid: "",
    price: "",
    subcategoryid: 0,
    isprivate: false,
    machinename: "",
    versionnumber: "",
    title: "",
    machinelogo: "",
    machinelogourl: "",
    machinedocument: "",
    machinedocumentname: "",
    industryid: "",
    shortdescription: "",
    detaildescription: "",
    inputdescription: "",
    outputdescription: "",
    inputsamplefile: "",
    outputsamplefile: "",
    inputsamplename: "",
    outputsamplename: "",
    osrequirmet: "",
    storage: "",
    ram: "",
    cpu: "",
    dependentmachineids: [],
    machinebanner: [],
    machinezipfile: "",
    // cloud: [],
    cloud: "",
    compatiblemachineids: [],
    machineconfigparameter: [],
    machinefaqs: [],
    parametershow: false,
    errors: {
      machineid: "",
      categoryid: "",
      machinename: "",
      versionnumber: "",
      title: "",
      industryid: "",
      shortdescription: "",
      detaildescription: "",
      inputdescription: "",
      outputdescription: "",
      inputsamplefile: "",
      outputsamplefile: "",
      dependentmachineids: [],
      machinezipfile: "",
      // cloud: [],
      cloud: "",
      compatiblemachineids: [],
      osrequirmet: "",
      ram: "",
      cpu: "",
      price: "",
      ValidationRules: [
        {
          FieldName: "title",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "machinename",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "versionnumber",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "industryid",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "categoryid",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "inputdescription",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "outputdescription",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "shortdescription",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "detaildescription",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "inputsamplefile",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "outputsamplefile",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "osrequirmet",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "ram",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "cpu",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "cloud",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "price",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });

  const handleCKEditor = (content, tag) => {
    setInput({
      ...input,
      [tag]: content,
      errors: {
        ...input.errors,
        [tag]: "",
      },
    });
  };

  const onFileChange = async (files) => {
    if (files) {
      let data = new FormData();
      data.append("jsonfile", files);
      data.append("callfrom", "create");
      if (machineid) {
        data.append(
          "machineid",
          parseInt(commonservices.bodyDecryption(machineid))
        );
      }
      const options = {
        headers: commonservices.getHeadersFromData(),
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          let percent = Math.floor((loaded * 100) / total);
          if (percent < 100) {
            setUploadPercentage(percent);
          }
        },
      };

      try {
        const res = await axios.post(
          API_URL.BASEURL + API_URL.MACHINEVALIDATEZIPFILE,
          data,
          options
        );
        if (res?.data?.status_code === 1) {
          const updatedData = res?.data?.data?.parameters.map(
            ({ detail, ...rest }) => ({
              ...rest,
              details: detail,
            })
          );
          setUploadPercentage(100);
          setTimeout(() => {
            setUploadPercentage(0);
          }, 1000);
          if (res?.data && res?.data?.data?.name && res?.data?.data?.version) {
            setFileRemoveButton(false);
            if (machineid) {
              if (res?.data?.data?.name !== input?.machinename) {
                return toast.error(
                  "Machine name do not match. Please check and try again."
                );
              }
            }
            if (res?.data?.data?.name?.length < 67) {
              const hasValidParaType = res?.data?.data?.parameters?.filter(
                (item) => {
                  if (!CONFIG_COMPONENT_NAME[item?.paratype]) {
                    return item;
                  }
                }
              );

              setInput((prevInput) => ({
                ...prevInput,
                machinebanner: [...prevInput.machinebanner],
                machinename: res?.data?.data?.name || prevInput?.machinename,
                versionnumber:
                  res?.data?.data?.version || prevInput?.versionnumber,
                machinezipfile:
                  res?.data?.data?.filepath || prevInput?.filepath,
                title: res?.data?.data?.title || prevInput?.title,
                shortdescription:
                  res?.data?.data?.short_description ||
                  prevInput?.shortdescription,
                detaildescription:
                  res?.data?.data?.long_description ||
                  prevInput?.detaildescription,
                machinefaqs: res?.data?.data?.faq || prevInput?.machinefaqs,
                machineconfigparameter:
                  updatedData || prevInput?.machineconfigparameter,
                osrequirmet:
                  res?.data?.data?.infrastructure?.os || prevInput?.osrequirmet,
                storage:
                  res?.data?.data?.infrastructure?.storage ||
                  prevInput?.storage,
                ram: res?.data?.data?.infrastructure?.memory || prevInput?.ram,
                cpu: res?.data?.data?.infrastructure?.cpu || prevInput?.cpu,
                cloud:
                  res?.data?.data?.infrastructure?.cloud || prevInput?.cloud,
                inputdescription:
                  res?.data?.data?.specification?.input ||
                  prevInput?.inputdescription,
                outputdescription:
                  res?.data?.data?.specification?.output ||
                  prevInput?.inputdescription,
                parametershow: hasValidParaType?.length > 0 ? false : true,
              }));
              toast.success(res?.data?.message);
            } else {
              toast.error(
                "Invalid Machine name in  ZIP of Project.json file. Ensure the machine name is no more than 67 characters."
              );
            }
          }
        } else {
          toast.error(res?.data?.message);
          if (!machineid) {
            setInput({
              ...input,
              machinename: "",
              machinelogo: "",
              versionnumber: "",
              machinelogourl: "",
              machinezipfile: "",
              title: "",
              shortdescription: "",
              detaildescription: "",
              machinefaqs: [],
              machineconfigparameter: [],
              osrequirmet: "",
              storage: "",
              ram: "",
              cpu: "",
              cloud: "",
              inputdescription: "",
              outputdescription: "",
              inputsamplename: "",
              outputsamplename: "",
              machinedocumentname: "",
            });
          }
        }
      } catch (error) {}
    } else {
      if (!machineid) {
        setFile("");
        setInput({
          machineid: 0,
          categoryid: "",
          price: "",
          subcategoryid: 0,
          isprivate: false,
          machinename: "",
          versionnumber: "",
          title: "",
          machinelogo: "",
          machinelogourl: "",
          machinedocument: "",
          machinedocumentname: "",
          industryid: "",
          shortdescription: "",
          detaildescription: "",
          inputdescription: "",
          outputdescription: "",
          inputsamplefile: "",
          outputsamplefile: "",
          inputsamplename: "",
          outputsamplename: "",
          osrequirmet: "",
          storage: "",
          ram: "",
          cpu: "",
          dependentmachineids: [],
          machinebanner: [],
          machinezipfile: "",
          // cloud: [],
          cloud: "",
          compatiblemachineids: [],
          machineconfigparameter: [],
          machinefaqs: [],
          parametershow: false,
          errors: {
            machineid: "",
            categoryid: "",
            machinename: "",
            versionnumber: "",
            title: "",
            industryid: "",
            shortdescription: "",
            detaildescription: "",
            inputdescription: "",
            outputdescription: "",
            inputsamplefile: "",
            outputsamplefile: "",
            dependentmachineids: [],
            machinezipfile: "",
            // cloud: [],
            cloud: "",
            compatiblemachineids: [],
            osrequirmet: "",
            ram: "",
            cpu: "",
            price: "",
            ValidationRules: [
              {
                FieldName: "title",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "machinename",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "versionnumber",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "industryid",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "categoryid",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "inputdescription",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "outputdescription",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "shortdescription",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "detaildescription",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "inputsamplefile",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "outputsamplefile",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "osrequirmet",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "ram",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "cpu",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "cloud",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
              {
                FieldName: "price",
                ValidationType: "required",
                ValidationMessage: "This Field is a required field",
              },
            ],
          },
        });
      } else {
        setInput({
          ...input,
          versionnumber: "",
          machinezipfile: "",
        });
        getMachineDetails();
      }
      fnClearAllValidation();
    }
  };
  const MachineBannerFileChange = async (e) => {
    // setBannerImageState(e?.target?.files?.[0]);
    const files = e?.target?.files;
    if (!files) return;
    let totalSize = 0;
    let temp = [];
    let invalidDimensions = false;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const img = new Image();
      img.src = URL.createObjectURL(file);
      await new Promise((resolve) => {
        img.onload = () => {
          if (
            img.width < 1400 ||
            img.width > 1450 ||
            img.height < 400 ||
            img.height > 450
          ) {
            invalidDimensions = true;
            toast.error(
              `Image dimensions for "${file.name}" must be between 1400-1450px width and 400-450px height.`
            );
          }
          resolve();
        };

        img.onerror = () => {
          toast.error(`Invalid file: "${file.name}"`);
          resolve();
        };
      });
      if (invalidDimensions) return;
      temp.push(file);
      totalSize += file?.size;
    }

    if (input?.machinebanner?.length > 0) {
      totalSize += input.machinebanner.reduce(
        (sum, file) => sum + file.size,
        0
      );
    }
    const combinedFiles =
      input?.machinebanner?.length > 0
        ? [...input.machinebanner, ...temp]
        : temp;
    if (combinedFiles.length > 7) {
      setBannerImgValidation("You can upload a maximum of 7 images.");
      setMultiSelectValidation({
        ...MultiSelectValidation,
        machinebanner: true,
      });
      e.target.value = "";
      return;
    }
    if (totalSize > 5000000) {
      setBannerImgValidation(
        "File size must not exceed 5 MB, and a maximum of 7 images can be uploaded."
      );
      setMultiSelectValidation({
        ...MultiSelectValidation,
        machinebanner: true,
      });
      e.target.value = "";
      return;
    }
    setBannerImageState(e?.target?.files?.[0]);

    setInput({
      ...input,
      machinebanner: combinedFiles,
    });
    setMultiSelectValidation({
      ...MultiSelectValidation,
      machinebanner: false,
    });
    setBannerImgValidation("");
    e.target.value = "";
  };

  const fnCommonFileChange = async (mainfile, type, tag) => {
    if (!mainfile) return;
    if (mainfile?.type !== type) {
      return toast.error(`${`Only ${type} are allowed.`}`);
    }
    if (tag === "outputsamplefile") {
      setOutputSpecificationFile(URL.createObjectURL(mainfile));

      setInput({
        ...input,
        [tag]: mainfile,
        ["outputsamplename"]: mainfile?.name,
        errors: {
          ...input.errors,
          [tag]: "",
        },
      });
    } else if (tag === "inputsamplefile") {
      setInputSpecificationFile(URL.createObjectURL(mainfile));

      setInput({
        ...input,
        [tag]: mainfile,
        ["inputsamplename"]: mainfile?.name,
        errors: {
          ...input.errors,
          [tag]: "",
        },
      });
    } else if (tag === "machinedocument") {
      setInput({
        ...input,
        [tag]: mainfile,
        ["machinedocumentname"]: mainfile?.name,
        errors: {
          ...input.errors,
          [tag]: "",
        },
      });
    }
  };
  async function getCategoryList() {
    let body = {
      categoryname: "",
    };
    dispatch(CategoryGetListDetail(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        setCategoryList(response?.payload?.data?.data);
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }
  async function getMachineLogoList() {
    setMachineLoader(false);
    let body = {
      tag: "",
    };
    dispatch(LogoGetList(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        setMachineLogoList(response?.payload?.data?.data);
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }
  async function getIndustryList() {
    let body = {
      industryname: "",
    };
    dispatch(GetList(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        setIndustryList(response?.payload?.data?.data);
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }
  function getProjectTermList() {
    dispatch(ProjectTermGetList({}))?.then((response) => {
      if (response?.payload?.isValidate) {
        if (response?.payload?.data?.data?.length > 0) {
          let cloudarray = [];
          response?.payload?.data?.data.forEach((element) => {
            if (element?.category === "Cloud") {
              cloudarray.push({
                value: element?.term,
                label: element?.term,
              });
            }
          });
          setProjectTermList({
            CPU: response?.payload?.data?.data.filter(
              (f) => f.category === "CPU"
            ),
            OS: response?.payload?.data?.data.filter(
              (f) => f.category === "Operating system"
            ),
            RAM: response?.payload?.data?.data.filter(
              (f) => f.category === "RAM"
            ),
            Storage: response?.payload?.data?.data.filter(
              (f) => f.category === "Storage"
            ),
            InputType: response?.payload?.data?.data.filter(
              (f) => f.category === "Input Type"
            ),
            // Cloud: cloudarray,
            Cloud: response?.payload?.data?.data.filter(
              (f) => f.category === "Cloud"
            ),
          });
        }
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }
  function handleMultiSelect(value, tag) {
    setInput((prevInput) => ({
      ...prevInput,
      [tag]: value
        ? value?.map((option) => ({
            label: option?.label,
            value: option?.value,
          }))
        : [],
    }));
  }
  async function getMachineList() {
    let body = {
      subscriberid: "",
      status: "Publish",
      categoryids: "",
      industryids: "",
    };
    dispatch(GetMachineDropdownList(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        let temp = [];
        response?.payload?.data?.data?.dataList1.forEach((element) => {
          temp.push({
            label: element?.machinename,
            value: element?.machineid,
          });
        });
        setMachineList(temp);
      }
      if (!response?.payload?.isValidate) {
      }
    });
  }
  useEffect(() => {
    getMachineList();
    getCategoryList();
    getProjectTermList();
    getIndustryList();
    getMachineLogoList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let obj = commonservices.fnCheckValidationOfObject(input);

      setInput({
        ...obj.obj,
      });
      let updatedValidation = { ...MultiSelectValidation };
      let totalBannerSize = 0;
      if (input?.machinebanner?.length > 0) {
        totalBannerSize = input.machinebanner.reduce(
          (acc, banner) => acc + (banner?.size || 0),
          0
        );
        if (totalBannerSize > 5000000 || input.machinebanner.length > 7) {
          updatedValidation.machinebanner = true;
          setBannerImgValidation(
            "File size must not exceed 5 MB, and a maximum of 7 images can be uploaded."
          );
        } else {
          updatedValidation.machinebanner = false;
          setBannerImgValidation("");
        }
      } else if (!machineid) {
        updatedValidation.machinebanner = true;
        setBannerImgValidation("At least one image is required.");
      }
      const updatedMachinelogo =
        typeof file === "object" && file !== null ? file : "";
      const updatedMachinelogourl = typeof file === "string" ? file : "";
      if (!updatedMachinelogo && !updatedMachinelogourl && !machineid) {
        updatedValidation.machinelogo = true;
      } else {
        updatedValidation.machinelogo = false;
        setMachineLogoValidation("");
      }
      setMultiSelectValidation(updatedValidation);
      if (
        obj.isValid &&
        !updatedValidation.machinebanner &&
        !updatedValidation.machinelogo
      ) {
        setMachineLoader(true);

        let formData = new FormData();

        let body = {
          machineid: input?.machineid,
          categoryid: input?.categoryid,
          price: input?.price ? parseFloat(input?.price) : 0,
          machinename: input?.machinename?.trim(),
          versionnumber: input?.versionnumber?.trim(),
          machinelogo: input?.machinelogo,
          machinelogourl: input?.machinelogourl,
          machinedocument: input?.machinedocument,
          isprivate: input?.isprivate,
          machineconfigparameter: input?.machineconfigparameter,
          machinefaqs: input?.machinefaqs,
          subcategoryid: input?.subcategoryid,
          title: input?.title?.trim(),
          industryid: input?.industryid,
          shortdescription: input?.shortdescription,
          detaildescription: input?.detaildescription,
          inputdescription: input?.inputdescription,
          inputsamplefile: input?.inputsamplefile,
          outputsamplefile: input?.outputsamplefile,
          outputdescription: input?.outputdescription,
          osrequirmet: input?.osrequirmet,
          ram: input?.ram,
          cpu: input?.cpu,
          machinezipfile: input?.machinezipfile,
          // dependentmachineids: input?.dependentmachineids,
          cloud: input?.cloud,
          // compatiblemachineids: input?.compatiblemachineids,Kone
          refmachineid: machineid
            ? parseInt(commonservices.bodyDecryption(machineid))
            : 0,
        };
        // if (input?.compatiblemachineids?.length > 0) {
        //   input.compatiblemachineids = input.compatiblemachineids
        //     .map((t) => t?.value)
        //     .join(",");
        // }
        // if (input?.dependentmachineids?.length > 0) {
        //   input.dependentmachineids =
        // }
        if (input?.dependentmachineids?.length > 0) {
          body["dependentmachineids"] = input.dependentmachineids
            .map((t) => t?.value)
            .join(",");
        }
        if (input?.compatiblemachineids?.length > 0) {
          body["compatiblemachineids"] = input.compatiblemachineids
            .map((t) => t?.value)
            .join(",");
        }

        for (const [key, value] of Object.entries(body)) {
          if (typeof value === "object" && Array.isArray(value)) {
            value?.forEach((item, index) => {
              for (const [nestedKey, nestedValue] of Object.entries(item)) {
                formData.append(`${key}[${index}].${nestedKey}`, nestedValue);
              }
            });
          } else {
            formData.append(`${key}`, value);
          }
        }

        input?.machinebanner?.forEach((file, index) => {
          formData.append(`machinebanner`, file);
        });

        let apiUrl = API_URL.BASEURL + API_URL.MACHINESAVE;
        if (machineid) {
          apiUrl = API_URL.BASEURL + API_URL.MACHINE.UPGRADE_MACHINE;
        }

        try {
          let resData = await axios({
            method: "POST",
            url: apiUrl,
            data: formData,
            headers: commonservices.getHeadersFromData(),
          });
          let response = apiResponse(true, resData?.data, setMachineLoader);
          if (response?.isValidate) {
            setMachineLoader(false);
            navigate("/machine");
          }
        } catch (apiError) {
          toast.error("An error occurred while saving the machine details.");
        } finally {
          setMachineLoader(false);
        }
      }
    } catch (error) {
      toast.error("An unexpected error occurred. Please try again later.");
    }
  };

  const fnInputChange = (value, tag) => {
    if (value) {
      if (tag === "categoryid") {
        setInput({
          ...input,
          [tag]: value,
          subcategoryid: 0,
          errors: {
            ...input.errors,
            [tag]: "",
          },
        });
      } else {
        setInput({
          ...input,
          [tag]: value,
          errors: {
            ...input.errors,
            [tag]: "",
          },
        });
      }
    } else {
      setInput({
        ...input,
        [tag]: "",
      });
    }
  };
  const handleWalkthroughCallback = () => {
    setCallApi(true);
  };
  async function getFAQList() {
    let body = { id: commonservices.bodyDecryption(machineid) };
    dispatch(FaqGetList(body))?.then((response) => {
      if (response?.payload?.isValidate) {
        faqListRef.current = response?.payload?.data?.data;
      }
      if (!response?.payload?.isValidate) {
        faqListRef.current = [];
      }
    });
  }

  const getMachineDetails = async () => {
    setMachineDetailLoader(true);
    dispatch(
      GetMachineDetailByPrimaryKey({
        id: commonservices.bodyDecryption(machineid),
      })
    )?.then(async (response) => {
      if (response?.payload?.isValidate) {
        setMachineDetailLoader(false);
        // getFAQList();
        let dataFromApi = response?.payload?.data?.data;
        let machineConfigList = [],
          faqList = [];
        dataFromApi?.dataList3?.forEach((item) => {
          let obj = {
            parakey: item?.parakey ? item?.parakey : "",
            paratype: item?.paratype ? item?.paratype : "",
            paravalueselection: item?.paravalueselection
              ? item?.paravalueselection
              : "",
            details: item?.details ? item?.details : "",
          };
          machineConfigList.push(obj);
        });
        if (faqListRef.current?.length > 0) {
          faqListRef.current?.forEach((item) => {
            let obj = {
              question: item?.question ? item?.question : "",
              answer: item?.answer ? item?.answer : "",
            };
            faqList.push(obj);
          });
        }

        const updateValue = (list, machineNameList) => {
          let updatedData = list?.map((item, index) => {
            return {
              label: machineNameList?.[index],
              value: item,
            };
          });
          return updatedData;
        };
        const updateCloudList = (list) => {
          let updatedData = list?.map((item) => {
            return {
              label: item,
              value: item,
            };
          });

          return updatedData;
        };
        let inputsamplefileblob = await commonservices.downloadFileFromURL(
          dataFromApi?.dataList1?.[0]?.inputsamplefileurl,
          {
            returnType: "blob",
          },
          dataFromApi?.dataList1?.[0]?.inputsamplefile
        );
        let outputsamplefileblob = await commonservices.downloadFileFromURL(
          dataFromApi?.dataList1?.[0]?.outputsamplefileurl,
          {
            returnType: "blob",
          },
          dataFromApi?.dataList1?.[0]?.outputsamplefile
        );
        let machinedocumentblob = await commonservices.downloadFileFromURL(
          dataFromApi?.dataList1?.[0]?.documentpathurl,
          {
            returnType: "blob",
          },
          dataFromApi?.dataList1?.[0]?.documentpath
        );
        setInput({
          ...input,
          machinedocumentname: dataFromApi?.dataList1?.[0]?.documentpath,
          machinedocument: dataFromApi?.dataList1?.[0]?.documentpathurl
            ? machinedocumentblob
            : "",
          inputsamplefile: inputsamplefileblob,
          // inputsamplefile: dataFromApi?.dataList1?.[0]?.inputsamplefileurl,
          outputsamplefile: outputsamplefileblob,
          // outputsamplefile: dataFromApi?.dataList1?.[0]?.outputsamplefileurl,
          inputsamplename: dataFromApi?.dataList1?.[0]?.inputsamplefile,
          outputsamplename: dataFromApi?.dataList1?.[0]?.outputsamplefile,
          title: dataFromApi?.dataList2?.[0]?.title,
          price: dataFromApi?.dataList1?.[0]?.price,
          machinename: dataFromApi?.dataList1?.[0]?.machinename,
          isprivate: dataFromApi?.dataList1?.[0]?.isprivate,
          shortdescription: dataFromApi?.dataList2?.[0]?.shortdescription,
          detaildescription: dataFromApi?.dataList2?.[0]?.detaildescription,
          industryid: dataFromApi?.dataList2?.[0]?.industryid,
          categoryid: dataFromApi?.dataList2?.[0]?.categoryid,
          subcategoryid: dataFromApi?.dataList2?.[0]?.subcategoryid,
          inputdescription: dataFromApi?.dataList2?.[0]?.inputdescription,
          outputdescription: dataFromApi?.dataList2?.[0]?.outputdescription,
          osrequirmet: dataFromApi?.dataList2?.[0]?.osrequirmet,
          storage: dataFromApi?.dataList2?.[0]?.storage,
          ram: dataFromApi?.dataList2?.[0]?.ram,
          cpu: dataFromApi?.dataList2?.[0]?.cpu,
          cloud: dataFromApi?.dataList2?.[0]?.cloud
            ? dataFromApi?.dataList2?.[0]?.cloud
            : "",
          machinezipfile: "",
          // cloud: dataFromApi?.dataList2?.[0]?.cloud
          //   ? updateCloudList(dataFromApi?.dataList2?.[0]?.cloud?.split(","))
          //   : [],
          machineconfigparameter: machineConfigList,
          compatiblemachineids: dataFromApi?.dataList2?.[0]
            ?.compatiblemachineids
            ? updateValue(
                dataFromApi?.dataList2?.[0]?.compatiblemachineids?.split(","),
                dataFromApi?.dataList2?.[0]?.compatiblemachines?.split(",")
              )
            : [],
          dependentmachineids: dataFromApi?.dataList2?.[0]?.dependentmachineids
            ? updateValue(
                dataFromApi?.dataList2?.[0]?.dependentmachineids?.split(","),
                dataFromApi?.dataList2?.[0]?.dependentmachines?.split(",")
              )
            : [],
          machinefaqs: faqList,
        });
        setFile(dataFromApi?.dataList1?.[0]?.machinelogo);
        setMachineBannerUpgradelist(dataFromApi?.dataList5);
        setMainImage(dataFromApi?.dataList5[0]?.bannerurl);
      }
      if (!response?.payload?.isValidate) {
      }
    });
  };

  useEffect(() => {
    if (machineid) {
      getMachineDetails();
      getFAQList();
    }
  }, [machineid]);
  const imageSrc1 =
    file && typeof file === "object"
      ? URL.createObjectURL(file)
      : file
      ? file
      : DemoLogo;

  const handleImageClick = (imageSrc) => {
    setMainImage(imageSrc);
  };

  function fnClearAllValidation() {
    setInput((prevInput) => {
      const clearedErrors = Object.fromEntries(
        Object.keys(prevInput.errors).map((key) => {
          // If the key is "errors", keep its value as is
          if (key === "ValidationRules") {
            return [key, prevInput.errors[key]];
          }
          // For all other keys, set the value to an empty string
          return [key, ""];
        })
      );
      return {
        ...prevInput,
        errors: clearedErrors,
      };
    });
    setMultiSelectValidation({
      machinebanner: false,
      machinelogo: false,
    });
  }

  return (
    <div className="schedular-page-main having-small-blue-bg">
      {MachineLoader && <MainpageLoader />}
      <div className="all-page-top">
        <Walkthrough
          callback={handleWalkthroughCallback}
          steps={steps?.Addmachine}
          run={!callApi}
          keyName="addMachine"
        />
        <Container>
          <div className="top-bot-section flex-column align-items-start gap-3">
            <div className="position-relative z-2">
              <BreadcrumbsNav pageNav={BreadcrumbSingle} />
            </div>
          </div>
        </Container>
        <div className="main-page-content addmachine-inner">
          <Container>
            <div className="py-3">
              <Form
              // onSubmit={(e) => {
              //   handleSubmit(e);
              // }}
              >
                <Row>
                  <Col md={8}>
                    <div className="tourAddMachineZip d-flex gap-3">
                      <div className="width-88">
                        <div className="position-relative special-position-relative width-88">
                          {file && (
                            <>
                              {!machineid && (
                                <button
                                  disabled={machineid ? true : false}
                                  type="reset"
                                  className="delete-img"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setFile("");

                                    setInput({
                                      ...input,
                                      machinelogo: "",
                                      machinelogourl: "",
                                    });
                                  }}
                                >
                                  <img src={closeImage} alt="deleteIcon" />
                                </button>
                              )}
                            </>
                          )}
                          {machineid && file === "" ? (
                            <div className="file-input machine-logo-loader height-88 width-88">
                              <Skeleton height={"100%"} width={"100%"} />
                            </div>
                          ) : (
                            <div
                              className={`file-input  height-88 width-88 ${
                                MultiSelectValidation?.machinelogo &&
                                "error-border-line"
                              }`}
                            >
                              {file ? (
                                <div
                                  ref={target1}
                                  onClick={(e) => {
                                    if (!machineid) {
                                      e.preventDefault();
                                      handleOverlay(e);
                                      setShow(!show);
                                      handleshowSortAndFilter();
                                    }
                                  }}
                                  className="drop-file-input-selected-image"
                                >
                                  <img
                                    src={imageSrc1}
                                    alt="machineicon"
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null;
                                      currentTarget.src = DemoLogo;
                                    }}
                                    className="main-selected-image"
                                  />
                                </div>
                              ) : (
                                <>
                                  <div
                                    title="Upload Machine Icon"
                                    ref={target1}
                                    onClick={(e) => {
                                      if (!machineid) {
                                        e.preventDefault();
                                        handleOverlay(e);
                                        setShow(!show);
                                        handleshowSortAndFilter();
                                      }
                                    }}
                                    className="drop-file-input height-88 width-88"
                                  >
                                    <div className="drop-file-input__label">
                                      <div>
                                        <img
                                          src={addbutton}
                                          alt="add icon"
                                          className="add-button"
                                        />
                                        <p className="mt-0">Icon</p>
                                        <p className="mt-0 addmachineicon-error">
                                          100 X 100 Pixels
                                        </p>
                                      </div>
                                    </div>
                                    <input
                                      type="file"
                                      accept="image/png, image/jpeg"
                                      disabled={machineid ? true : false}
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                          {showSortAndFilter ? (
                            <>
                              <Overlay
                                target={target1.current}
                                show={showSortAndFilter}
                                placement="bottom"
                              >
                                {(props) => (
                                  <Tooltip id="overlay-example" {...props}>
                                    <CustomLogoUploadPopup
                                      input={input}
                                      setinput={setInput}
                                      loader={MachineLogoLoader}
                                      data={MachineLogoList}
                                      file1={file}
                                      setfile={setFile}
                                      multiselectvalidation={
                                        MultiSelectValidation
                                      }
                                      setmultiselectvalidation={
                                        setMultiSelectValidation
                                      }
                                      machineidupgrade={machineid}
                                      handleshowPopup={handleshowSortAndFilter}
                                    />
                                  </Tooltip>
                                )}
                              </Overlay>
                            </>
                          ) : (
                            ""
                          )}
                          {MultiSelectValidation?.machinelogo && (
                            <p className="error-line">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={MachineLogoValidation}
                                />
                              </span>
                            </p>
                          )}
                        </div>
                      </div>
                      <div style={{ width: "calc(100% - 100px)" }}>
                        <DropFileInput
                          removefile={FileRemoveButton}
                          uploadPercentage={uploadPercentage}
                          onFileChange={(files) => onFileChange(files)}
                        />
                      </div>
                    </div>
                    {machineid ? (
                      <div className="mt-3 position-relative mb12 tourAddMachineBannerImage">
                        <>
                          {mainImage !== "" ? (
                            <img
                              src={mainImage ? mainImage : DemoLogoBig}
                              alt="annualsummary1"
                              className="main-big-img"
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null;
                                currentTarget.src = DemoLogoBig;
                              }}
                            />
                          ) : (
                            <Skeleton height={250} width={"100%"} />
                          )}
                          <div className="smaller-size-images">
                            {MachineBannerUpgradelist.length > 0 &&
                              MachineBannerUpgradelist.map(
                                (item_d5, index_d5) => (
                                  <React.Fragment key={index_d5}>
                                    <img
                                      src={item_d5?.thumbnailurl}
                                      alt="annualsummary1"
                                      className={
                                        mainImage === item_d5?.thumbnailurl
                                          ? "smaller-size-img active"
                                          : "smaller-size-img"
                                      }
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        currentTarget.src = DemoLogo;
                                      }}
                                      onClick={() =>
                                        handleImageClick(item_d5?.bannerurl)
                                      }
                                    />
                                  </React.Fragment>
                                )
                              )}
                          </div>
                        </>
                      </div>
                    ) : (
                      <div className="mt-3 position-relative mb12 tourAddMachineBannerImage">
                        <div
                          className={` ${
                            MultiSelectValidation.machinebanner &&
                            "error-border-line"
                          }`}
                        >
                          {input?.machinebanner?.length > 0 ? (
                            <>
                              <div className="drop-file-input ">
                                {BannerImageState !== "" ? (
                                  <>
                                    <img
                                      className="banner-img-one"
                                      src={URL?.createObjectURL(
                                        BannerImageState
                                      )}
                                      alt="BannerImage"
                                    />
                                    {!machineid && (
                                      <div className="airobot cursor-pointer">
                                        <img
                                          src={robot}
                                          alt="robot"
                                          onClick={(e) => {
                                            setAIModalShow(true);
                                          }}
                                        />
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <div className="drop-file-input__label d-block">
                                      <div>
                                        <h5>Drag 'n' drop files here</h5>
                                        <p>
                                          Banner Images - Supported only jpg,
                                          jpeg & png files
                                        </p>
                                        <p className="red-color-text">
                                          Height between 400 to 450 Pixels and
                                          Width between 1400 to 1450 Pixels
                                        </p>
                                      </div>
                                      <Button
                                        className={`${
                                          machineid
                                            ? "disabled-btn cursor-none"
                                            : "blue-btn"
                                        } w-auto position-static mt16`}
                                      >
                                        Choose Files
                                      </Button>
                                    </div>
                                    <input
                                      type="file"
                                      id="machinebanner"
                                      ref={MachineLogoref}
                                      multiple
                                      title=""
                                      accept=".jpg, .jpeg, .png"
                                      onChange={MachineBannerFileChange}
                                    />
                                  </>
                                )}
                              </div>
                              <div className="all-sm-images-wrapper">
                                {input?.machinebanner?.map(
                                  (item_mb, index_mb) => (
                                    <div
                                      key={index_mb}
                                      className={
                                        BannerImageState === item_mb
                                          ? "active single-sm-images-wrapper position-relative"
                                          : "single-sm-images-wrapper position-relative"
                                      }
                                    >
                                      <img
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setBannerImageState(item_mb);
                                        }}
                                        src={URL?.createObjectURL(item_mb)}
                                        // src={
                                        //   typeof item_mb === "object"
                                        //     ? URL.createObjectURL(item_mb)
                                        //     : item_mb
                                        // }
                                      />
                                      <button
                                        type="reset"
                                        className="delete-img"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          const updatedMachineBanner = [
                                            ...input?.machinebanner,
                                          ];
                                          updatedMachineBanner.splice(
                                            index_mb,
                                            1
                                          );
                                          const totalmb =
                                            updatedMachineBanner.reduce(
                                              (sum, file) => sum + file?.size,
                                              0
                                            );

                                          setInput({
                                            ...input,
                                            machinebanner: updatedMachineBanner,
                                          });
                                          if (updatedMachineBanner.length > 7) {
                                            setMultiSelectValidation({
                                              ...MultiSelectValidation,
                                              machinebanner: true,
                                            });
                                            setBannerImgValidation(
                                              "You can upload a maximum of 7 images."
                                            );
                                          } else if (totalmb > 5000000) {
                                            setMultiSelectValidation({
                                              ...MultiSelectValidation,
                                              machinebanner: true,
                                            });
                                            setBannerImgValidation(
                                              "File size must not exceed 5 MB, and a maximum of 7 images can be uploaded."
                                            );
                                          } else {
                                            setBannerImageState(
                                              updatedMachineBanner[0]
                                            );
                                            setMultiSelectValidation({
                                              ...MultiSelectValidation,
                                              machinebanner: false,
                                            });
                                            setBannerImgValidation("");
                                          }
                                        }}
                                      >
                                        <img
                                          src={closeImage}
                                          alt="deleteIcon"
                                        />
                                      </button>
                                    </div>
                                  )
                                )}

                                <label
                                  className="only-plus-input-type-file"
                                  for="machinebanner"
                                >
                                  <div className="only-plus-input-typ-file-addbutton">
                                    <img src={blueaddicon} alt="blueaddicon" />
                                  </div>
                                  <input
                                    type="file"
                                    className="form-control"
                                    id="machinebanner"
                                    ref={MachineLogoref}
                                    multiple
                                    accept="image/png, image/jpeg"
                                    onChange={MachineBannerFileChange}
                                  />
                                </label>
                              </div>
                            </>
                          ) : (
                            <div className="drop-file-input">
                              <div className="drop-file-input__label d-block">
                                <div>
                                  <h5>Drag 'n' drop files here</h5>
                                  <p>
                                    Banner Images - Supported only jpg, jpeg &
                                    png files
                                  </p>
                                  <p className="red-color-text">
                                    Height between 400 to 450 Pixels and Width
                                    between 1400 to 1450 Pixels
                                  </p>
                                </div>
                                <Button
                                  className={`${
                                    machineid
                                      ? "disabled-btn cursor-none"
                                      : "blue-btn"
                                  } w-auto position-static mt16`}
                                >
                                  Choose Files
                                </Button>
                              </div>
                              <input
                                type="file"
                                id="machinebanner"
                                ref={MachineLogoref}
                                multiple
                                title=""
                                disabled={machineid ? true : false}
                                accept=".jpg, .jpeg, .png"
                                onChange={MachineBannerFileChange}
                              />
                              {!machineid && (
                                <div className="mainairobot-data d-flex">
                                  <div className="airobot cursor-pointer">
                                    <img
                                      src={robot}
                                      alt="robot"
                                      onClick={(e) => {
                                        setAIModalShow(true);
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                          {MultiSelectValidation.machinebanner && (
                            <p className="error-line">
                              <span className="error-message-icon">
                                <img
                                  src={infoIcon}
                                  alt="infoIcon"
                                  title={BannerImgValidation}
                                />
                              </span>
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="machine-detail-main mt16">
                      <h4 className="machine-detail-title d-flex justify-content-between align-items-center">
                        <div>Details </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <p>This Machine Is ?</p>

                          <Dropdown className="public-private-dropdown ms-2">
                            <Dropdown.Toggle id="isprivate">
                              {!input?.isprivate ? "Public" : "Private"}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item
                                disabled={machineid ? true : false}
                                className={!input?.isprivate ? "active" : ""}
                                href="#"
                                onClick={(e) => {
                                  setInput({
                                    ...input,
                                    isprivate: false,
                                  });
                                }}
                              >
                                <h6>Public</h6>
                                <p>
                                  This machine is public, allowing all users
                                  access to run and view results.
                                </p>
                              </Dropdown.Item>
                              <Dropdown.Item
                                disabled={machineid ? true : false}
                                className={input?.isprivate ? "active" : ""}
                                href="#"
                                onClick={(e) => {
                                  setInput({
                                    ...input,
                                    isprivate: true,
                                  });
                                }}
                              >
                                <h6>Private</h6>
                                <p>
                                  This machine is set to private, accessible
                                  only to you for secure, exclusive use.
                                </p>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </h4>
                      <div className="machine-detail-main-body">
                        <p className="machine-detail-sub-text">
                          Machine configuration refers to setting and adjusting
                          specific parameters or values that determine the
                          behavior and performance of machines for optimal
                          operation.
                        </p>
                        <Row>
                          <div className="tourAddMachineOverview pb-1">
                            <Row>
                              <h5 className="machine-detail-inner-title">
                                Overview
                              </h5>
                              <Col md={6}>
                                <Form.Group className="form-group mb16">
                                  <Form.Label className="common-label">
                                    Machine Name
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <Form.Control
                                    disabled
                                    type="text"
                                    placeholder="Machine Name"
                                    className="common-input"
                                    maxLength={67}
                                    value={input.machinename}
                                    onChange={(e) =>
                                      fnInputChange(
                                        e.target.value,
                                        "machinename"
                                      )
                                    }
                                    isInvalid={input?.errors?.machinename}
                                  />
                                  {input.errors.machinename && (
                                    <Form.Control.Feedback type="invalid">
                                      {input.errors.machinename}
                                    </Form.Control.Feedback>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="form-group mb16">
                                  <Form.Label className="common-label">
                                    Version
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <Form.Control
                                    disabled
                                    type="text"
                                    placeholder="Version"
                                    className="common-input"
                                    maxLength={167}
                                    value={input.versionnumber}
                                    onChange={(e) =>
                                      fnInputChange(
                                        e.target.value,
                                        "versionnumber"
                                      )
                                    }
                                    // isInvalid={input?.errors?.versionnumber}
                                  />
                                  {/* {input.errors.versionnumber && (
                                    <Form.Control.Feedback type="invalid">
                                      {input.errors.versionnumber}
                                    </Form.Control.Feedback>
                                  )} */}
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="form-group mb16">
                                  <Form.Label className="common-label">
                                    Title
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <Form.Control
                                      type="text"
                                      placeholder="Title"
                                      className="common-input"
                                      maxLength={67}
                                      value={input?.title}
                                      onChange={(e) =>
                                        fnInputChange(e.target.value, "title")
                                      }
                                      isInvalid={input?.errors?.title}
                                    />
                                    {input.errors.title && (
                                      <Form.Control.Feedback type="invalid">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={input.errors.title}
                                          />
                                        </span>
                                      </Form.Control.Feedback>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="form-group mb16">
                                  <Form.Label className="common-label">
                                    Price
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <Form.Control
                                      // type="text"
                                      placeholder="Price"
                                      disabled={machineid}
                                      className="common-input"
                                      maxLength={4}
                                      type="text"
                                      // pattern="^\d*\.?\d{0,2}$"
                                      value={input?.price}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        const regex = /^\d*\.?\d{0,2}$/;

                                        if (regex.test(value)) {
                                          fnInputChange(value, "price");
                                        }
                                      }}
                                      isInvalid={input?.errors?.price}
                                    />
                                    {input.errors.price && (
                                      <Form.Control.Feedback type="invalid">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={input.errors.price}
                                          />
                                        </span>
                                      </Form.Control.Feedback>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group
                                  className="mb-3"
                                  controlId="formProfilePic"
                                >
                                  <Form.Label className="common-label">
                                    Upload Document
                                  </Form.Label>
                                  <div className="position-relative">
                                    <div>
                                      <label
                                        className="filelabel-browse-file w-100"
                                        for="app_json"
                                      >
                                        <div className="filelabel-browse-file-inner">
                                          <span>
                                            {input?.machinedocumentname
                                              ? input?.machinedocumentname
                                              : "Pdf File"}
                                          </span>
                                          <div className="browse-btn-in-input">
                                            Browse
                                          </div>
                                          <input
                                            id="app_json"
                                            type="file"
                                            ref={Pdfref}
                                            accept="application/pdf"
                                            onChange={(e) => {
                                              if (e.target.files[0]) {
                                                fnCommonFileChange(
                                                  e.target.files[0],
                                                  "application/pdf",
                                                  "machinedocument"
                                                );
                                                e.target.value = "";
                                              }
                                            }}
                                          />
                                        </div>
                                      </label>
                                    </div>
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={12}>
                                <Form.Group
                                  className="mb-3"
                                  controlId="formProfilePic"
                                >
                                  <Form.Label className="common-label">
                                    Short Description
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <div
                                      className={`${
                                        input.errors.shortdescription &&
                                        "error-border-line"
                                      }`}
                                    >
                                      <CKeditorComponent
                                        onChange={handleCKEditor}
                                        tag="shortdescription"
                                        value={input?.shortdescription}
                                      />
                                    </div>
                                    {input.errors.shortdescription && (
                                      <p className="error-line">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={
                                              input.errors.shortdescription
                                            }
                                          />
                                        </span>
                                      </p>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={12}>
                                <Form.Group controlId="formProfilePic">
                                  <Form.Label className="common-label">
                                    Detail Description
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <div
                                      className={`${
                                        input.errors.detaildescription &&
                                        "error-border-line"
                                      }`}
                                    >
                                      <CKeditorComponent
                                        onChange={handleCKEditor}
                                        tag="detaildescription"
                                        value={input?.detaildescription}
                                      />
                                    </div>
                                    {input.errors.detaildescription && (
                                      <p className="error-line">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={
                                              input.errors.detaildescription
                                            }
                                          />
                                        </span>
                                      </p>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                            </Row>
                          </div>
                          <div className="tourAddMachineClassification mt-3 pb-1">
                            <Row>
                              <h5 className="machine-detail-inner-title">
                                Classification
                              </h5>
                              <Col md={6}>
                                <Form.Group className="form-group mb16">
                                  <Form.Label className="common-label">
                                    Industry
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <Form.Select
                                      className="common-select"
                                      disabled={machineid}
                                      value={input.industryid}
                                      onChange={(e) =>
                                        fnInputChange(
                                          parseInt(e.target.value),
                                          "industryid"
                                        )
                                      }
                                      isInvalid={input?.errors?.industryid}
                                    >
                                      <option value="">Select</option>
                                      {IndustryList?.length > 0 &&
                                        IndustryList?.map(
                                          (item_cd, index_cd) => (
                                            <option
                                              key={index_cd}
                                              value={item_cd?.industryid}
                                            >
                                              {item_cd?.industryname}
                                            </option>
                                          )
                                        )}
                                    </Form.Select>
                                    {input.errors.industryid && (
                                      <Form.Control.Feedback type="invalid">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={input.errors.industryid}
                                          />
                                        </span>
                                      </Form.Control.Feedback>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="form-group mb16">
                                  <Form.Label className="common-label">
                                    Category
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <Form.Select
                                      className="common-select"
                                      disabled={machineid}
                                      value={input.categoryid}
                                      onChange={(e) =>
                                        fnInputChange(
                                          parseInt(e.target.value),
                                          "categoryid"
                                        )
                                      }
                                      isInvalid={input?.errors?.categoryid}
                                    >
                                      <option value="">Select</option>
                                      {CategoryList?.length > 0 &&
                                        CategoryList?.map(
                                          (item_cd, index_cd) =>
                                            item_cd?.refcategoryid === 0 && (
                                              <option
                                                key={index_cd}
                                                value={item_cd?.categoryid}
                                              >
                                                {item_cd?.categoryname}
                                              </option>
                                            )
                                        )}
                                    </Form.Select>
                                    {input?.errors?.categoryid && (
                                      <Form.Control.Feedback type="invalid">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={input.errors.categoryid}
                                          />
                                        </span>
                                      </Form.Control.Feedback>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="form-group">
                                  <Form.Label className="common-label">
                                    Sub Category
                                  </Form.Label>
                                  <div className="position-relative">
                                    <Form.Select
                                      className="common-select"
                                      disabled={machineid}
                                      value={input.subcategoryid}
                                      onChange={(e) =>
                                        fnInputChange(
                                          parseInt(e.target.value),
                                          "subcategoryid"
                                        )
                                      }
                                      isInvalid={input?.errors?.subcategoryid}
                                    >
                                      <option value="">Select</option>
                                      {input?.categoryid > 0 &&
                                        CategoryList?.length > 0 &&
                                        CategoryList?.map(
                                          (item_cd, index_cd) =>
                                            parseInt(input?.categoryid) ===
                                              parseInt(
                                                item_cd?.refcategoryid
                                              ) && (
                                              <option
                                                key={index_cd}
                                                value={item_cd?.categoryid}
                                              >
                                                {item_cd?.categoryname}
                                              </option>
                                            )
                                        )}
                                    </Form.Select>
                                    {input.errors.subcategoryid && (
                                      <Form.Control.Feedback type="invalid">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={input.errors.subcategoryid}
                                          />
                                        </span>
                                      </Form.Control.Feedback>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                            </Row>
                          </div>

                          <div className="tourAddMachineCompAndDep mt-3 pb-1">
                            <Row>
                              <h5 className="machine-detail-inner-title">
                                Compatibility and Dependencies
                              </h5>
                              <Col md={12}>
                                <Form.Group className="form-group mb16">
                                  <Form.Label className="common-label">
                                    Preferred Dependent Machines
                                  </Form.Label>
                                  <div
                                    className={` ${
                                      MultiSelectValidation.dependentmachineids &&
                                      "error-border-line"
                                    }`}
                                  >
                                    <Select
                                      options={MachineList}
                                      isMulti
                                      placeholder="Select"
                                      value={input.dependentmachineids}
                                      onChange={(e) =>
                                        handleMultiSelect(
                                          e,
                                          "dependentmachineids"
                                        )
                                      }
                                    />
                                  </div>
                                  {MultiSelectValidation.dependentmachineids && (
                                    <p className="error-line">
                                      This Field is a required field
                                    </p>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col md={12}>
                                <Form.Group className="form-group">
                                  <Form.Label className="common-label">
                                    Compatible Machines
                                  </Form.Label>
                                  <div
                                    className={` ${
                                      MultiSelectValidation.compatiblemachineids &&
                                      "error-border-line"
                                    }`}
                                  >
                                    <Select
                                      options={MachineList}
                                      isMulti
                                      placeholder="Select"
                                      value={input.compatiblemachineids}
                                      onChange={(e) =>
                                        handleMultiSelect(
                                          e,
                                          "compatiblemachineids"
                                        )
                                      }
                                    />
                                  </div>
                                  {MultiSelectValidation.compatiblemachineids && (
                                    <p className="error-line">
                                      This Field is a required field
                                    </p>
                                  )}
                                </Form.Group>
                              </Col>
                            </Row>
                          </div>
                          <div className="tourAddMachineSpecAndSample mt-3 pb-1">
                            <Row>
                              <h5 className="machine-detail-inner-title">
                                Specification & Sample Data
                              </h5>
                              <Col md={12}>
                                <Form.Group
                                  className="mb-3"
                                  controlId="formProfilePic"
                                >
                                  <Form.Label className="common-label">
                                    Upload Input Sample Data (json file)
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <div
                                      className={`file-input height-40 ${
                                        input.errors.inputsamplefile &&
                                        "error-border-line"
                                      }`}
                                    >
                                      <label
                                        className="filelabel-browse-file w-100"
                                        for="inputsamplefile"
                                      >
                                        <div className="filelabel-browse-file-inner">
                                          <span>
                                            {input?.inputsamplename
                                              ? input?.inputsamplename
                                              : "Json File"}
                                          </span>
                                          <div className="browse-btn-in-input">
                                            Browse
                                          </div>
                                          <input
                                            id="inputsamplefile"
                                            type="file"
                                            ref={InputFileRef}
                                            accept="application/json"
                                            // onChange={(e) =>
                                            //   fnCommonFileChange(
                                            //     e.target.files[0],
                                            //     "application/json",
                                            //     "inputsamplefile"
                                            //   )
                                            // }
                                            onChange={(e) => {
                                              if (e.target.files[0]) {
                                                fnCommonFileChange(
                                                  e.target.files[0],
                                                  "application/json",
                                                  "inputsamplefile"
                                                );
                                                e.target.value = "";
                                              }
                                            }}
                                          />
                                        </div>
                                      </label>
                                    </div>
                                    {input.errors.inputsamplefile && (
                                      <p className="error-line">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={input.errors.inputsamplefile}
                                          />
                                        </span>
                                      </p>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={12}>
                                <Form.Group
                                  className="mb-3"
                                  controlId="formProfilePic"
                                >
                                  <Form.Label className="common-label">
                                    Input Specifications
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <div
                                      className={`${
                                        input.errors.inputdescription &&
                                        "error-border-line"
                                      }`}
                                    >
                                      <CKeditorComponent
                                        onChange={handleCKEditor}
                                        tag="inputdescription"
                                        value={input?.inputdescription}
                                      />
                                    </div>
                                    {input.errors.inputdescription && (
                                      <p className="error-line">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={
                                              input.errors.inputdescription
                                            }
                                          />
                                        </span>
                                      </p>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={12}>
                                <Form.Group
                                  className="mb-3"
                                  controlId="formProfilePic"
                                >
                                  <Form.Label className="common-label">
                                    Upload Output Sample Data (json file)
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>

                                  <div className="position-relative">
                                    <div
                                      className={`file-input height-40 ${
                                        input.errors.outputsamplefile &&
                                        "error-border-line"
                                      }`}
                                    >
                                      <label
                                        className="filelabel-browse-file w-100"
                                        for="profileImg4"
                                      >
                                        <div className="filelabel-browse-file-inner">
                                          <span>
                                            {input?.outputsamplename
                                              ? input?.outputsamplename
                                              : "Json File"}
                                          </span>
                                          <div className="browse-btn-in-input">
                                            Browse
                                          </div>
                                          <input
                                            type="file"
                                            id="profileImg4"
                                            ref={OutputFileRef}
                                            accept="application/json"
                                            // onChange={(e) =>
                                            //   fnCommonFileChange(
                                            //     e.target.files[0],
                                            //     "application/json",
                                            //     "outputsamplefile"
                                            //   )
                                            // }
                                            onChange={(e) => {
                                              if (e.target.files[0]) {
                                                fnCommonFileChange(
                                                  e.target.files[0],
                                                  "application/json",
                                                  "outputsamplefile"
                                                );
                                                e.target.value = "";
                                              }
                                            }}
                                          />
                                        </div>
                                      </label>
                                    </div>
                                    {input.errors.outputsamplefile && (
                                      <p className="error-line">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={
                                              input.errors.outputsamplefile
                                            }
                                          />
                                        </span>
                                      </p>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>

                              <Col md={12}>
                                <Form.Group controlId="formProfilePic">
                                  <Form.Label className="common-label">
                                    Output Specifications
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <div
                                      className={`${
                                        input.errors.outputdescription &&
                                        "error-border-line"
                                      }`}
                                    >
                                      <CKeditorComponent
                                        onChange={handleCKEditor}
                                        tag="outputdescription"
                                        value={input?.outputdescription}
                                      />
                                    </div>
                                    {input.errors.outputdescription && (
                                      <p className="error-line">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={
                                              input.errors.outputdescription
                                            }
                                          />
                                        </span>
                                      </p>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                            </Row>
                          </div>
                          <div className="tourAddMachineInfra mt-3 pb-1">
                            <Row>
                              <h5 className="machine-detail-inner-title">
                                Infrastructure Requirement
                              </h5>
                              <Col md={6}>
                                <Form.Group className="form-group mb16">
                                  <Form.Label className="common-label">
                                    OS Requirement
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <Form.Select
                                      className="common-select"
                                      value={input?.osrequirmet}
                                      onChange={(e) =>
                                        fnInputChange(
                                          e.target.value,
                                          "osrequirmet"
                                        )
                                      }
                                      isInvalid={input?.errors?.osrequirmet}
                                    >
                                      <option value="">Select</option>
                                      {ProjectTermList.OS?.length > 0 &&
                                        ProjectTermList.OS?.map(
                                          (item_cd, index_cd) => (
                                            <option
                                              key={index_cd}
                                              value={item_cd?.term}
                                            >
                                              {item_cd?.term}
                                            </option>
                                          )
                                        )}
                                    </Form.Select>
                                    {input.errors.osrequirmet && (
                                      <Form.Control.Feedback type="invalid">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={input.errors.osrequirmet}
                                          />
                                        </span>
                                      </Form.Control.Feedback>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="form-group mb16">
                                  <Form.Label className="common-label">
                                    RAM
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <Form.Select
                                      className="common-select"
                                      value={input.ram}
                                      onChange={(e) =>
                                        fnInputChange(e.target.value, "ram")
                                      }
                                      isInvalid={input?.errors?.ram}
                                    >
                                      <option value="">Select</option>
                                      {ProjectTermList.RAM?.length > 0 &&
                                        ProjectTermList.RAM?.map(
                                          (item_cd, index_cd) => (
                                            <option
                                              key={index_cd}
                                              value={item_cd?.term}
                                            >
                                              {item_cd?.term}
                                            </option>
                                          )
                                        )}
                                    </Form.Select>
                                    {input.errors.ram && (
                                      <Form.Control.Feedback type="invalid">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={input.errors.ram}
                                          />
                                        </span>
                                      </Form.Control.Feedback>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="form-group">
                                  <Form.Label className="common-label">
                                    CPU
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <Form.Select
                                      className="common-select"
                                      value={input.cpu}
                                      onChange={(e) =>
                                        fnInputChange(e.target.value, "cpu")
                                      }
                                      isInvalid={input?.errors?.cpu}
                                    >
                                      <option value="">Select</option>
                                      {ProjectTermList.CPU?.length > 0 &&
                                        ProjectTermList.CPU?.map(
                                          (item_cd, index_cd) => (
                                            <option
                                              key={index_cd}
                                              value={item_cd?.term}
                                            >
                                              {item_cd?.term}
                                            </option>
                                          )
                                        )}
                                    </Form.Select>
                                    {input.errors.cpu && (
                                      <Form.Control.Feedback type="invalid">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={input.errors.cpu}
                                          />
                                        </span>
                                      </Form.Control.Feedback>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col md={6}>
                                <Form.Group className="form-group">
                                  <Form.Label className="common-label">
                                    Cloud
                                    <span className="ms-1 red-color-text">
                                      *
                                    </span>
                                  </Form.Label>
                                  <div className="position-relative">
                                    <Form.Select
                                      className="common-select"
                                      value={input.cloud}
                                      onChange={(e) =>
                                        fnInputChange(e.target.value, "cloud")
                                      }
                                      isInvalid={input?.errors?.cloud}
                                    >
                                      <option value="">Select</option>
                                      {ProjectTermList.Cloud?.length > 0 &&
                                        ProjectTermList.Cloud?.map(
                                          (item_cd, index_cd) => (
                                            <option
                                              key={index_cd}
                                              value={item_cd?.term}
                                            >
                                              {item_cd?.term}
                                            </option>
                                          )
                                        )}
                                    </Form.Select>
                                    {input?.errors?.cloud && (
                                      <p className="error-line">
                                        <span className="error-message-icon">
                                          <img
                                            src={infoIcon}
                                            alt="infoIcon"
                                            title={input?.errors?.cloud}
                                          />
                                        </span>
                                      </p>
                                    )}
                                  </div>
                                </Form.Group>
                              </Col>
                            </Row>
                          </div>
                        </Row>
                      </div>
                    </div>
                    {input?.parametershow &&
                      input?.machinezipfile &&
                      input?.machinename &&
                      input?.versionnumber && (
                        <div className="machin-detail-footer-btns">
                          <button
                            type="reset"
                            disabled={MachineLoader}
                            onClick={(e) => {
                              e.preventDefault();
                              // setFileRemoveButton(true);
                              // if (!machineid) {
                              //   setFile("");
                              //   setInput({
                              //     ...input,
                              //     categoryid: "",
                              //     price: "",
                              //     subcategoryid: 0,
                              //     isprivate: false,
                              //     machinename: "",
                              //     versionnumber: "",
                              //     title: "",
                              //     machinelogo: "",
                              //     machinelogourl: "",
                              //     machinedocument: "",
                              //     industryid: "",
                              //     shortdescription: "",
                              //     detaildescription: "",
                              //     inputdescription: "",
                              //     outputdescription: "",
                              //     inputsamplefile: "",
                              //     outputsamplefile: "",
                              //     osrequirmet: "",
                              //     storage: "",
                              //     ram: "",
                              //     cpu: "",
                              //     dependentmachineids: [],
                              //     machinebanner: [],
                              //     machinezipfile: "",
                              //     cloud: "",
                              //     compatiblemachineids: [],
                              //     machineconfigparameter: [],
                              //     machinefaqs: [],
                              //     parametershow: false,
                              //     inputsamplename: "",
                              //     outputsamplename: "",
                              //     machinedocumentname: "",
                              //   });
                              // } else {
                              //   setInput({
                              //     ...input,
                              //     versionnumber: "",
                              //   });
                              // }
                              // fnClearAllValidation();

                              navigate(-1);
                            }}
                            className="grey-btn"
                          >
                            Cancel
                          </button>
                          <button
                            className="blue-btn"
                            disabled={MachineLoader}
                            // type="submit"
                            onClick={(e) => {
                              e.preventDefault();
                              if (OrganizationList?.length > 1) {
                                setShowOrgAlertModal(true);
                              } else {
                                handleSubmit(e);
                              }
                            }}
                          >
                            {MachineLoader ? <SubmitLoading /> : "Save"}
                          </button>
                        </div>
                      )}
                  </Col>
                  <Col md={4}>
                    <div className="machine-detail-main tourAddMachineParaConfig">
                      <div>
                        <h4 className="machine-detail-title">
                          Parameters Configuration{" "}
                        </h4>
                      </div>
                      <div className="machine-detail-main-body">
                        <p className="machine-detail-sub-text">
                          Parameters configuration refers to setting and
                          adjusting specific variables or values that influence
                          the behavior of machine.
                        </p>
                        <Row></Row>

                        {input?.machineconfigparameter?.length > 0 ? (
                          input?.machineconfigparameter?.map((item, index) => {
                            return (
                              <Row key={index}>
                                <Col
                                  md={12}
                                  className="my-2 position-relative machine-config-parameter"
                                >
                                  <div className="all-actions">
                                    <img
                                      src={editAction}
                                      title="edit"
                                      alt="editAction"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setParameterModalIndex(index);
                                        setParameterModalType("Edit");
                                        setParameterModalShow(true);
                                      }}
                                    />
                                    <img
                                      src={deleteAction}
                                      title="delete"
                                      alt="deleteAction"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setDeleteparafaqShow(true);
                                        setDeleteparafaqtype({
                                          type: "parameter",
                                          index: index,
                                        });
                                        // input?.machineconfigparameter?.splice(
                                        //   index,
                                        //   1
                                        // );
                                        // const hasValidParaType =
                                        //   input?.machineconfigparameter?.filter(
                                        //     (item) => {
                                        //       if (
                                        //         !CONFIG_COMPONENT_NAME[
                                        //           item?.paratype
                                        //         ]
                                        //       ) {
                                        //         return item;
                                        //       }
                                        //     }
                                        //   );
                                        // setInput({
                                        //   ...input,
                                        //   parametershow:
                                        //     hasValidParaType?.length > 0
                                        //       ? false
                                        //       : true,
                                        //   machineconfigparameter: [
                                        //     ...input.machineconfigparameter,
                                        //   ],
                                        // });
                                      }}
                                    />
                                  </div>
                                  {React.createElement(
                                    CONFIG_COMPONENT_NAME[item?.paratype]
                                      ? CONFIG_COMPONENT_NAME[item?.paratype]
                                      : CONFIG_COMPONENT_NAME["Default"],
                                    {
                                      compObj: item,
                                      showtype: true,
                                    }
                                  )}
                                </Col>
                              </Row>
                            );
                          })
                        ) : (
                          <Nodata />
                        )}
                        {MultiSelectValidation.machineconfigparameter && (
                          <p className="error-line">
                            Please add any one Parametes
                          </p>
                        )}

                        <div className="text-center">
                          <button
                            disabled={!input?.machinezipfile}
                            type="reset"
                            className="add-more-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              setParameterModalType("Add");
                              setParameterModalShow(true);
                            }}
                          >
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                              >
                                <g clip-path="url(#clip0_589_8666)">
                                  <path
                                    d="M12.5 5V19"
                                    stroke="#2490D2"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M5.5 12H19.5"
                                    stroke="#2490D2"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_589_8666">
                                    <rect
                                      width="24"
                                      height="24"
                                      fill="white"
                                      transform="translate(0.5)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <span>Add Parameter</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="machine-detail-main mt-3 tourAddMachineFaq">
                      <h4 className="machine-detail-title">
                        Frequently Asked Questions (FAQs){" "}
                      </h4>
                      <div className="machine-detail-main-body">
                        <p className="machine-detail-sub-text">
                          Frequently asked questions(FAQ), improving customer
                          support and providing quick, accurate answers for
                          users.
                        </p>
                        {input?.machinefaqs?.length > 0 ? (
                          <ul className="faqsecmachine">
                            {input?.machinefaqs?.map((item, index) => {
                              return (
                                <li key={index}>
                                  <Row key={index}>
                                    <Col md={12} className="my-2">
                                      <div className="d-flex justify-content-between gap-4">
                                        <p className="faq-question faqwidth">
                                          {item?.question}
                                        </p>
                                        <div className="all-actions">
                                          <img
                                            src={editAction}
                                            title="edit"
                                            alt="editAction"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              faqDetailRef.current = {
                                                id: index,
                                                que: item?.question,
                                                ans: item?.answer,
                                              };
                                              setShowFaqModal(true);
                                            }}
                                          />
                                          <img
                                            src={deleteAction}
                                            title="delete"
                                            alt="deleteAction"
                                            onClick={(e) => {
                                              setDeleteparafaqShow(true);
                                              setDeleteparafaqtype({
                                                type: "faq",
                                                index: index,
                                              });
                                              // let updatedData =
                                              //   input?.machinefaqs?.filter(
                                              //     (x, i) => i !== index
                                              //   );

                                              // setInput({
                                              //   ...input,
                                              //   machinefaqs: updatedData,
                                              // });
                                            }}
                                          />
                                        </div>
                                      </div>
                                      <p
                                        className="faq-answer faqwidth"
                                        dangerouslySetInnerHTML={{
                                          __html: item?.answer,
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                </li>
                              );
                            })}
                          </ul>
                        ) : (
                          <Nodata />
                        )}

                        <div className="text-center">
                          <button
                            disabled={!input?.machinezipfile}
                            type="reset"
                            className="add-more-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              faqDetailRef.current = {
                                id: -1,
                                que: "",
                                ans: "",
                              };
                              setShowFaqModal(true);
                            }}
                          >
                            <span>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                              >
                                <g clip-path="url(#clip0_589_8666)">
                                  <path
                                    d="M12.5 5V19"
                                    stroke="#2490D2"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M5.5 12H19.5"
                                    stroke="#2490D2"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_589_8666">
                                    <rect
                                      width="24"
                                      height="24"
                                      fill="white"
                                      transform="translate(0.5)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <span>Add More FAQs</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </Container>
        </div>
        {ParameterModalShow && (
          <AddEditParameterModal
            type={ParameterModalType}
            data={input}
            ParameterModalIndex={ParameterModalIndex}
            setinvalidparashowgtn={setInvalidParaShowBtn}
            setInput={setInput}
            ProjectTermList={ProjectTermList}
            show={ParameterModalShow}
            onHide={() => setParameterModalShow(false)}
          />
        )}
        {showFaqModal && (
          <AddEditFaqModal
            showModal={showFaqModal}
            closeModal={closeFaqModal}
            faqDetail={faqDetailRef.current}
            handleFaqList={handleFaqList}
          />
        )}
        {AIModalShow && (
          <AIImageGenerateModal
            setbannerimagestate={setBannerImageState}
            show={AIModalShow}
            input={input}
            setinput={setInput}
            onHide={(e) => setAIModalShow(false)}
          />
        )}
        {DeleteparafaqShow && (
          <DeleteParaFAQModal
            type={Deleteparafaqtype}
            show={DeleteparafaqShow}
            input={input}
            setinput={setInput}
            onHide={(e) => setDeleteparafaqShow(false)}
          />
        )}
        {showOrgAlertModal && (
          <OrganizationAlertModal
            show={showOrgAlertModal}
            handleSubmit={handleSubmit}
            onHide={(e) => setShowOrgAlertModal(false)}
          />
        )}
      </div>
    </div>
  );
};
export default AddMachine;
